import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'normalize.css';
import axios from 'axios';
import JSEncrypt from 'jsencrypt';
import * as forge from 'node-forge'

const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app');




axios.get(`https://btgb-2021-web-app.azurewebsites.net/crypto`).then((res) => {
  Vue.prototype.$getRsaCode = function (str) { // 註冊

    const pki = forge.pki;
    var publicKey = `${res.data.pk}`;
    const publicK = pki.publicKeyFromPem(
        '-----BEGIN PUBLIC KEY-----\n' + publicKey + '\n-----END PUBLIC KEY-----'
      );
      const encrypted = publicK.encrypt(forge.util.encodeUtf8(str.toString()));

      const passwordCrypto = forge.util.encode64(encrypted);

    let data = passwordCrypto;

    // console.log(data);
    return data;
  }
});
